import { Spin } from "antd";
import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { queryParam } from "../../utils";
import { VENDOR_LOGO } from "../../utils/data";
import UserNameInput from "./userNameInput";

import NewPasswordInput from "./newPasswordInput";
import OtpVerify from "./otpVerify";

const ForgotPassword = (props) => {
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const history = useHistory();

  const userParams = (field) => {
    let s = queryParam(props.location.search);
    if (s[field]) return s[field];
  };

  return (
    <div>
      <div className="container ">
        <Row style={{ marginTop: "6%" }}>
          <Col md={{ span: 4, offset: 4 }}>
            <Spin spinning={loader}>
              <Card>
                <Card.Body>
                  <div className="text-center">
                    <img
                      src={VENDOR_LOGO}
                      className="bg-white rounded-3 mb-3"
                      style={{ width: "120px" }}
                    />
                  </div>
                  <h5 className="fw-bold">Forgot Password</h5>

                  {!userParams("type") && <UserNameInput {...props} />}
                  {userParams("type") == "otp" && <OtpVerify {...props} />}
                  {userParams("type") == "password" && (
                    <NewPasswordInput {...props} />
                  )}
                </Card.Body>
              </Card>
            </Spin>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ForgotPassword;
